import React from 'react';
import { Button, Col, Row } from 'reactstrap';

import history from '../../utils/history';
import { Desktop, Mobile } from '../Common/const';
import NotificationPopUp from './NotificationPopUp';

class Notifications extends React.Component {
  state = {
    cancelPopUpOpen: false,
  };

  handleButtonClick = () => {
    this.props.closeNotificationTop(false);
    history.push(this.props.buttonLink);
  };

  openCancelAccountPopUp = (value) => {
    this.setState('cancelPopUpOpen', value);
  };

  render() {
    return (
      <div>
        {this.props.showNotificationTop && (
          <div className="notification-holder">
            <Row>
              <Desktop>
                <Col className="d-flex flex-column col-lg-7">
                  <b>{this.props.title}</b>
                  <span>{this.props.subtitle}</span>
                </Col>
                <Col className="text-right col-lg-5  pr-4">
                  <Button
                    color="link"
                    onClick={this.handleButtonClick}
                    className="btn btn-outline rounded-lg"
                  >
                    {this.props.buttonText}
                  </Button>
                </Col>
              </Desktop>
              <Mobile>
                <Col>
                  <Row className="d-flex flex-column text-center">
                    <b>{this.props.title}</b>
                    <span>{this.props.subtitle}</span>
                  </Row>
                  <Row className="text-center mt-2">
                    <Button
                      color="link"
                      onClick={this.handleButtonClick}
                      className="btn btn-outline rounded-lg mt-1 m-auto"
                    >
                      {this.props.buttonText}
                    </Button>
                  </Row>
                </Col>
              </Mobile>
              <i
                className="icon-close"
                onClick={() => this.props.closeNotificationTop(false)}
              />
            </Row>
          </div>
        )}
        <NotificationPopUp
          isOpen={this.state.cancelPopUpOpen}
          openCancelAccountPopUp={this.openCancelAccountPopUp}
          buttonLink={this.props.buttonLink}
          user={this.props.user}
        />
      </div>
    );
  }
}

export default Notifications;
